import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  paper: {
    minWidth: 300,
    maxHeight: '50vh',
    borderRadius: 0,
  },
}));
